import type { FiscalShiftAction } from '@/entities/fiscalization';

export type CashShiftUiAction = Exclude<FiscalShiftAction, null>;

export const CASH_SHIFT_UI_EVENT = 'mors:cash-shift-action';

export function requestCashShiftUi(action: CashShiftUiAction): boolean {
  if (typeof window === 'undefined') return false;

  window.dispatchEvent(new CustomEvent<CashShiftUiAction>(CASH_SHIFT_UI_EVENT, { detail: action }));
  return true;
}
